<script setup>
import { ref, onMounted, watch, watchEffect } from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from "axios";
import { useLoading } from "vue-loading-overlay";

const $loading = useLoading();

const router = useRouter();
const route = useRoute();

const menus = ref([
  {
    name: "即時警示",
    icon: "warning_amber",
    iconType: "round",
    path: "/instant-alert",
  },
  {
    name: "實時監控",
    icon: "camera_alt",
    iconType: "outlined",
    path: "/real-time-monitoring",
  },
  {
    name: "歷史資料",
    icon: "access_time",
    iconType: "round",
    path: "/history-data",
    children: [
      {
        name: "雷達",
        path: "/history-data/radar",
      },
      {
        name: "攝影機",
        path: "/history-data/camera",
      },
    ],
  },
  {
    name: "圖表分析",
    icon: "signal_cellular_alt",
    iconType: "round",
    path: "/chart-analysis",
  },
  // 參數設定（PS）— 2026-08-27 客戶確認不提供寫入 API，本次不交付，故隱藏入口。
  // 路由與 SettingsView.vue 均保留，客戶日後補上儲存端點時取消註解即可。
  // {
  //   name: "參數設定",
  //   icon: "settings",
  //   iconType: "outlined",
  //   path: "/settings",
  // },
]);
</script>

<template>
  <aside class="sidebar col-12 col-md-3 col-lg-2 p-4" id="navbar">
    <router-link to="/" class="navbar-brand d-block mb-5">
      <img src="@/assets/logo.png" class="img-fluid" />
    </router-link>

    <ul class="nav flex-column">
      <template v-for="menu in menus" :key="menu.path">
        <li v-if="!menu.children" class="nav-item">
          <router-link
            :to="{ path: menu.path }"
            class="nav-link dropdown-toggle"
            :class="{
              active:
                route.path == menu.path ||
                (menu.path === '/instant-alert' && route.path === '/'),
            }"
          >
            <span
              :class="{
                'material-icons-outlined': menu.iconType == 'outlined',
                'material-icons-round': menu.iconType == 'round',
              }"
              :style="menu.icon === 'camera_alt' ? { top: '1px' } : {}"
            >
              {{ menu.icon }}
            </span>
            {{ menu.name }}
            <span class="material-icons-round ms-auto me-1" style="top: 0px">
              keyboard_arrow_right
            </span>
          </router-link>
        </li>

        <li v-else class="nav-item dropdown show">
          <button
            type="button"
            class="nav-link dropdown-toggle"
            data-bs-display="static"
            data-bs-toggle="dropdown"
            data-bs-auto-close="false"
          >
            <span class="material-icons-round"> access_time </span>歷史資料
            <span class="material-icons-round ms-auto me-1">
              keyboard_arrow_right
            </span>
          </button>
          <div class="dropdown-menu show">
            <router-link
              v-for="item in menu.children"
              :to="{ path: item.path }"
              class="dropdown-item"
              :key="item.path"
            >
              {{ item.name }}
            </router-link>
          </div>
        </li>
      </template>
    </ul>

    <!--
      「資料時間」原本寫死為 2025/07/02，客戶看到會誤以為資料只到該日（2026-08-27 實測抓到）。
      在確定要以哪個來源作為資料時間之前先隱藏；若要恢復，應改為由 API 帶入實際的最新資料時間，
      不可再寫死日期。
    <small class="text-center mt-auto">資料時間 : {{ dataTime }}</small>
    -->
  </aside>
</template>

<style scoped></style>
